// extracted by mini-css-extract-plugin
export default {"topicBanner_img":"index_topicBanner_img_zlK2N"};